export const categories = [
  {
    slug: 'anquan-denglu',
    name: '安全登录',
    description: '了解最新的安全登录技术和最佳实践，保护您的账户安全',
    icon: 'ri-shield-check-line',
  },
  {
    slug: 'zhanghu-guanli',
    name: '账户管理',
    description: '掌握账户管理技巧，高效管理您的开云登录账户',
    icon: 'ri-user-settings-line',
  },
  {
    slug: 'pingtai-dongtai',
    name: '平台动态',
    description: '开云登录平台最新资讯、功能更新和活动公告',
    icon: 'ri-notification-3-line',
  },
  {
    slug: 'jishu-zixun',
    name: '技术资讯',
    description: '行业前沿技术动态，探索登录认证领域的最新发展',
    icon: 'ri-code-s-slash-line',
  },
  {
    slug: 'shiyong-zhinan',
    name: '使用指南',
    description: '详细的开云登录使用教程和操作指南，快速上手',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'xingye-dongcha',
    name: '行业洞察',
    description: '深度分析登录服务行业发展趋势和市场动态',
    icon: 'ri-line-chart-line',
  },
];